<template>
    <div class="pay-container">
        <head-bar title="转账" :fixed="true"></head-bar>
        <div class="info-box">
            <div class="info-item-box">
                <div class="caption">
                    <span>订单信息</span>
                </div>
                <div class="info-list">
                    <div class="text-item">
                        <span>订单号:&nbsp;{{ orderNumber }}</span>
                    </div>
                    <div class="text-item">
                        <span
                            >应付金额:&nbsp;<em>¥{{ orderPrice }}</em></span
                        >
                    </div>
                    <div class="text-item">
                        <span
                            >剩余支付时间:&nbsp;<em>{{ times }}</em></span
                        >
                    </div>
                </div>
            </div>
            <!-- <div class="info-item-box margin-top">
                <div class="caption">
                    <span>转账信息</span>
                </div>
                <div class="info-list">
                    <div class="text-item">
                        <span>公司名称:深圳市油柑科技有限公司</span>
                    </div>
                    <div class="text-item">
                        <span
                            >开户银行:中国工商银行股份有限公司深圳华强支行</span
                        >
                    </div>
                    <div class="text-item">
                        <span>银行账号:4000 0221 0920 0744 484</span>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="button-group">
            <div class="next-button" @click="goToRemittance">
                <span>下一步</span>
            </div>
        </div>
    </div>
</template>
<script>
import HeadBar from "@/components/HeadBar.vue";
import utils from "@/utils/utils";
export default {
    name: "PayOffline",
    components: {
        HeadBar,
    },
    created() {
        let { orderNo, orderPrice, invoiceId = "" } = this.$route.query;
        let _this = this;
        if (!orderNo) {
            this.$router.push("/");
            return false;
        }
        this.orderNumber = orderNo;
        this.orderPrice = orderPrice;
        this.$axios
            .post(_this.$api.orderApi.order_getOrderCancelTime, {
                orderNo: orderNo,
            })
            .then((response) => {
                let seconds = response.data || 0;
                utils.countDownConversion(seconds, (times, isEnd) => {
                    _this.times = times;
                    if (isEnd) {
                        _this.$router.push("/");
                    }
                });
            })
            .catch(() => {
                _this.$router.push("/");
            });
    },
    data() {
        return {
            orderNumber: 0,
            orderPrice: 0,
            times: "00:00:00",
        };
    },
    methods: {
        goToRemittance() {
            let { orderNo, invoiceId = "" } = this.$route.query;
            this.$router.push({
                path: "/pay_remittance",
                query: {
                    orderNo,
                    invoiceId,
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.pay-container {
    width: 750px;
    padding-top: 92px;
    .info-box {
        padding: 60px 40px;
        background-color: #fff;
        .info-item-box {
            &.margin-top {
                margin-top: 40px;
            }
            .caption {
                margin-bottom: 30px;
                font-size: 28px;
                font-weight: 400;
                color: #333333;
            }
            .text-item {
                margin-bottom: 5px;
                font-size: 28px;
                line-height: 40px;
                color: #333;
                em {
                    font-weight: 600;
                    color: #ff5500;
                }
            }
        }
    }
    .button-group {
        margin: 60px auto;
        width: 690px;
        height: auto;
        .next-button {
            width: 690px;
            height: 70px;
            background-color: #4bc227;
            border-radius: 36px;
            font-size: 28px;
            line-height: 70px;
            text-align: center;
            color: #fff;
        }
    }
}
</style>
